import styled from 'styled-components';
import { User } from '../ArticleCard/ArticleCard.styles';
import { ThemeProps } from '@/styles/global';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 3.75rem;
  min-width: 18.75rem;
  margin-bottom: 5rem;
  @media (max-width: 992px) {
    padding-left: 1.875rem;
    padding-right: 1.875rem;
  }
  @media (max-width: 768px) {
    padding-left: 1rem;
    padding-right: 1rem;
    margin-bottom: 2.5rem;
  }
`;

export const BackImage = styled.div`
  width: 100%;
  height: 26rem;
  background: url('/articleBack.webp') no-repeat center center;
  background-size: cover;
  border-radius: 0.5rem;
  @media (max-width: 768px) {
    height: 16rem;
  }
  @media (max-width: 460px) {
    height: 16rem;
    background-image: url('/articleBackMobile.webp');
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 60rem;
  margin-top: -10rem;
  @media (max-width: 1140px) {
    max-width: 96%;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: -7.875rem;
  }
`;

export const TitleContainer = styled.div`
  width: 100%;
  border-radius: 0.5rem;
  padding: 5rem;
  background-color: #fff;
  box-shadow: 0px 0px 4px rgba(89, 115, 114, 0.16);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media (max-width: 992px) {
    padding: 3rem 1.875rem;
  }
  @media (max-width: 768px) {
    padding: 1.5rem 1rem;
    margin: 0 1rem;
    width: auto;
  }
`;

export const Title = styled.h1`
  font-weight: 700;
  font-size: 2rem;
  line-height: 2.75rem;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 1.125rem;
    line-height: 1.5rem;
  }
`;

export const Author = styled(User)`
  justify-content: center;
  p {
    margin: 0 1.5rem;
  }
`;

export const Description = styled.h2`
  margin: 4rem 0 3rem;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 2rem;
  @media (max-width: 768px) {
    margin: 2rem 0 1rem;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
`;

export const Text = styled.div`
  p {
    padding: 0.45rem 0;
    margin: 0;
    font-weight: 400;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: -0.003em;
    color: ${(props: ThemeProps) => props.theme.blackColor};
    opacity: 0.8;
    @media (max-width: 768px) {
      padding: 0.4rem 0;
    }
  }
`;

export const EmbeddedImage = styled.img`
  float: left;
  padding: 1.25rem 2.5rem 1.25rem 0;
  border: 1px;
  box-sizing: initial;
  @media (max-width: 768px) {
    float: none;
    padding: 1rem 0;
    max-width: 100%;
  }
`;

export const Quote = styled.blockquote`
  margin: 2.5rem 0;
  padding: 1.25rem 2.5rem;
  border-left: 6px solid #10a823;
`;
